export type AppInstallType = 'Available' | 'ForceInstalled' | 'Blocked' | 'RequiredForSetup' | 'Kiosk';
export type AutoUpdateMode = 'Default' | 'Postponed' | 'HighPriority';
export type DefaultPermissionPolicy = 'Prompt' | 'Grant' | 'Deny';

// Mapping a numeros (como vienen en el JSON del backend - System.Text.Json serializa enums como numeros por default)
export const AppInstallTypeMap: Record<number, AppInstallType> = {
  0: 'Available',
  1: 'ForceInstalled',
  2: 'Blocked',
  3: 'RequiredForSetup',
  4: 'Kiosk',
};

export const AppInstallTypeLabels: Record<AppInstallType, string> = {
  Available: 'Disponible',
  ForceInstalled: 'Forzar instalacion',
  Blocked: 'Bloqueada',
  RequiredForSetup: 'Requerida en setup',
  Kiosk: 'Kiosko',
};

export const AutoUpdateModeMap: Record<number, AutoUpdateMode> = {
  0: 'Default',
  1: 'Postponed',
  2: 'HighPriority',
};

export const AutoUpdateModeLabels: Record<AutoUpdateMode, string> = {
  Default: 'Por defecto',
  Postponed: 'Postergado',
  HighPriority: 'Alta prioridad',
};

export const DefaultPermissionPolicyMap: Record<number, DefaultPermissionPolicy> = {
  0: 'Prompt',
  1: 'Grant',
  2: 'Deny',
};

export const DefaultPermissionPolicyLabels: Record<DefaultPermissionPolicy, string> = {
  Prompt: 'Preguntar',
  Grant: 'Conceder',
  Deny: 'Denegar',
};

export interface ProfileDto {
  id: number;
  enterpriseId: number;
  enterpriseName: string;
  name: string;
  displayNameEs: string;
  description?: string | null;
  googlePolicyId?: string | null;
  lastSyncAt?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string | null;
  devicesCount: number;
  appsCount: number;
  apps: ProfileAppDto[];
}

export interface ProfileAppDto {
  id: number;
  appId: number;
  appPackageName: string;
  appTitle: string;
  appIconUrl?: string | null;
  installType: number;
  autoUpdateMode: number;
  defaultPermissionPolicy: number;
}

export interface CreateProfileRequest {
  enterpriseId: number;
  name: string;
  displayNameEs: string;
  description?: string;
}

export interface UpdateProfileRequest {
  displayNameEs: string;
  description?: string;
}

export interface AddAppToProfileRequest {
  appId: number;
  installType: number;
  autoUpdateMode: number;
  defaultPermissionPolicy: number;
}

export interface UpdateProfileAppRequest {
  installType: number;
  autoUpdateMode: number;
  defaultPermissionPolicy: number;
}

export interface ProfileListRequest {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortDescending?: boolean;
  includeInactive?: boolean;
  enterpriseId?: number;
}
